export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      class: 'mt-2',
      icon: 'fa fa-dashboard'
    },
    {
      name: 'Ticket',
      url: '/tickets',
      icon: 'fa fa-tasks'
    },
    {
      name: 'Visited Sites',
      url: '/visited-sites',
      icon: 'fa fa-building'
    },
    {
      name: 'Settings',
      icon: 'fa fa-cogs',
      children: [
        {
          name: 'User',
          url: '/settings/user',
          icon: 'fa fa-group'
        },
        {
          name: 'Sites',
          url: '/settings/sites',
          icon: 'fa fa-building'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js